import { CALL_VERIFF_API } from '../app/middleware/callVeriffApi';

/**
 * Screen primary owner against AML watchlists
 * @param {object} personData - { firstName, lastName, dateOfBirth? }
 */
export const screenPrimaryOwner = (personData) => ({
    types: ['AML_SCREEN_PRIMARY_REQUEST', 'AML_SCREEN_PRIMARY_SUCCESS', 'AML_SCREEN_PRIMARY_FAILURE'],
    [CALL_VERIFF_API]: true,
    personData,
    screeningType: 'primaryOwner'
});

/**
 * Screen a beneficial owner against AML watchlists
 * @param {object} personData - { firstName, lastName, dateOfBirth? }
 * @param {number} ownerIndex - Index of the beneficial owner in the array
 */
export const screenBeneficialOwner = (personData, ownerIndex) => ({
    types: ['AML_SCREEN_BENEFICIAL_REQUEST', 'AML_SCREEN_BENEFICIAL_SUCCESS', 'AML_SCREEN_BENEFICIAL_FAILURE'],
    [CALL_VERIFF_API]: true,
    personData,
    screeningType: 'beneficialOwner',
    ownerIndex
});

/**
 * Clear all AML screening results
 */
export const clearAmlResults = () => ({
    type: 'AML_CLEAR_RESULTS'
});

/**
 * Set AML screening results from loaded KYC data
 * @param {object} amlScreening - Previously saved AML screening data
 */
export const setAmlResults = (amlScreening) => ({
    type: 'AML_SET_RESULTS',
    data: amlScreening
});

/**
 * Set loading state for AML screening
 */
export const setAmlLoading = () => ({
    type: 'AML_SET_LOADING'
});

/**
 * Clear loading state for AML screening
 */
export const setAmlNotLoading = () => ({
    type: 'AML_SET_NOT_LOADING'
});
